import { Controller, useFormContext } from 'react-hook-form';

import ReactSelect from 'dashboard/components/ReactSelect';
import { EditorableSchema } from 'dashboard/components-lib/FieldSchemaEditor/constants';
import { InputLabel } from 'dashboard/components-lib/FieldSchemaEditorForm/shared';
import Spacer from 'design-system/components/Spacer';

interface RetentionControls {
  fieldSchema: EditorableSchema;
  fieldName: string;
  formContext: ReturnType<typeof useFormContext>;
  canEdit: (fieldSchema: EditorableSchema) => boolean;
}

export const DataRetentionControls: React.FC<RetentionControls> = ({
  fieldSchema,
  fieldName,
  formContext,
  canEdit,
}) => {
  const { control } = formContext;

  return (
    <>
      <Spacer height={2} />
      <InputLabel htmlFor='field-schema-panel__field-redaction-policy'>Redaction policy</InputLabel>
      <Controller
        name={`${fieldName}.config.redaction-policy`}
        control={control}
        render={({ field: { value, onChange } }) => (
          <ReactSelect
            id='field-schema-panel__field-redaction-policy'
            aria-label='Redaction policy'
            value={value}
            options={[
              { label: 'None', value: 'none' },
              { label: 'Never', value: 'never' },
            ]}
            onChange={onChange}
            disabled={!canEdit(fieldSchema)}
          />
        )}
      />
      <Spacer height={2} />
      <InputLabel htmlFor='field-schema-panel__field-write-policy'>Write policy</InputLabel>
      <Controller
        name={`${fieldName}.config.write-policy`}
        control={control}
        render={({ field: { value, onChange } }) => (
          <ReactSelect
            id='field-schema-panel__field-write-policy'
            aria-label='Write policy'
            value={value}
            options={[
              { label: 'None', value: 'none' },
              { label: 'Write Once', value: 'write_once' },
            ]}
            onChange={onChange}
            disabled={!canEdit(fieldSchema)}
          />
        )}
      />
    </>
  );
};
